import React from "react";
import Layout from "../assets/Layout";
import UserLayout from "../assets/UserLayout";
import { Box, Button, Divider, Grid, IconButton, InputBase, Paper, Rating, Stack, TextField, Typography } from "@mui/material";
import adImage from '../images/adImage.png'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import facebookIcon from '../images/facebookIcon.svg';
import twitterIcon from '../images/twitterIcon.svg';
import linkedinIcon from '../images/linkedinIcon.svg';
import instagramIcon from '../images/instagramIcon.svg';
import VideocamRoundedIcon from '@mui/icons-material/VideocamRounded';
import { servicefeature } from "../styles/style";
import { ArrowForwardIos } from "@mui/icons-material";
import CandidateCoachServiceReviewCard from "../components/Candidate/CandidateCoachServiceReviewCard";
import SearchIcon from "@mui/icons-material/Search";

const CandidateServiceOrderDetailPage = () => {
    return (
        <>
            <Layout>
                <UserLayout>

                <Box sx={{ display: 'flex', flexDirection: 'row', mt: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Service Name</Typography>
                        <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
                            <TextField
                                sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                className='profile-skills-box text2Light'
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                              
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            />
                        </Grid>
                    </Box>

            
                    <Grid container>
                        <Grid item md={9} >
                            <Box p={{md:5, xs:1}}>
                                <Paper
                                    sx={{
                                        width: "100%",
                                        bgcolor: "#F8FAFF",
                                        boxShadow:
                                            "0px 40.30877685546875px 80.6175537109375px -15.115790367126465px #3665D014",
                                        border: "1.72px solid #cedefd",
                                    }}
                                >
                                    <Box sx={{ p: 3, display: "flex", flexDirection:{md:'row', xs:'column'}, justifyContent: "center" }}>
                                        <Box>
                                            <img
                                                src={adImage}
                                                alt="profilePhoto"
                                                style={{ height: "200px" }}
                                            />
                                        </Box>
                                        <Box sx={{ fontFamily: "Inter", px: 3 }}>
                                            <Typography
                                                sx={{
                                                    lineHeight: "43px",
                                                    opacity: ".5",
                                                }}
                                                className="text1Mid"
                                            >
                                                (8784421)
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    lineHeight: "40px",
                                                    color: "#061C3D",
                                                }}
                                                className="subHeading2Bold"
                                            >
                                                Anuj Sharma
                                            </Typography>
                                            <Rating
                                                defaultValue={4}
                                                precision={0.5}
                                                readOnly
                                                sx={{ py: 1 }}
                                                className="text1Bold"
                                            />
                                            <Typography
                                                sx={{
                                                    lineHeight: "35px",
                                                }}
                                                className=""
                                            >
                                                Lorem ipsum dolor sit amet consectetur. Turpis in sapien in
                                                a nunc nibh volutpat. Massa mattis molestie amet dui
                                                volutpat. Tellus lacinia pulvinar pharetra viverra morbi
                                                tincidunt mi mus.
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Paper>



                                <Box my={'5'}>
                                    <Typography
                                        sx={{
                                            lineHeight: "5rem",
                                            textAlign: "left",
                                        }}
                                        className="subHeading1Bold"
                                    >
                                        About Anuj Sharma
                                    </Typography>
                                    <Typography
                                        sx={{
                                            lineHeight: "2rem",
                                            textAlign: "left",
                                        }}
                                        className="subHeading2Mid">
                                        Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus. Lobortis maecenas pulvinar pretium est morbi ut diam pulvinar. Pellentesque id lacus id elit leo cursus purus tempus tortor. Amet ultricies proin egestas egestas pellentesque adipiscing euismod sit imperdiet.
                                    </Typography>
                                    <Typography
                                        sx={{
                                            lineHeight: "2rem",
                                            textAlign: "left",
                                            mt: 3
                                        }}
                                        className="subHeading2Mid">
                                        Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa Amet ultricies proin egestas egestas pellentesque adipiscing euismod sit imperdiet.
                                    </Typography>
                                </Box>

                                <Paper sx={{
                                    border: '1.28px solid #D2D2D24D', boxShadow: '0px 40.996337890625px 81.99267578125px -15.373626708984375px #3665D014', my: 3
                                }}>
                                    <Box p={3}>
                                        <Box>
                                            <Typography sx={{
                                                lineHeight: "4.25rem",
                                                textAlign: "left",
                                                mt: 1
                                            }}
                                                className="subHeading2Bold">Service Detail</Typography>
                                            <ul style={{
                                                lineHeight: "1.75rem",
                                                textAlign: "left",
                                            }}
                                                className="text1Mid">
                                                <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                                                <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. </li>
                                                <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                                                <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. </li>
                                            </ul>
                                        </Box>
                                        <Box>
                                            <Typography sx={{
                                                lineHeight: "4rem",
                                                textAlign: "left",
                                                mt: 1
                                            }}
                                                className="heading2bold">Service Detail by Coach</Typography>
                                            <ul style={{
                                                lineHeight: "1.75rem",
                                                textAlign: "left",
                                            }}
                                                className="text1Mid">
                                                <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                                                <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. </li>
                                                <li style={{ paddingBottom: '20px' }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Tellus lacinia pulvinar pharetra viverra morbi tincidunt mi mus.</li>
                                                <li style={{ paddingBottom: '20px', fontWeight: 700, }}>Lorem ipsum dolor sit amet consectetur. Turpis in sapien in a nunc nibh volutpat. Massa mattis molestie amet dui volutpat. </li>
                                            </ul>
                                        </Box>
                                        <Box>
                                            <Box>
                                                <Typography sx={{
                                                    lineHeight: "5rem",
                                                    textAlign: "left",
                                                    mt: 1
                                                }}
                                                    className="heading2bold">Medium Available </Typography>
                                                <Box display={{ display: 'flex', flexDirection:{md:'row', xs:'column'}, gap: 15 }}>
                                                    <Box sx={{ bgcolor: '#2544EE', color: '#fff', px: 3, py: 1, borderRadius: '30px', height:'45px' }}> <VideocamRoundedIcon /></Box>
                                                  
                                                    <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Language: <span style={{ color: '#2544EE' }}>English</span></Typography></Box>
                                                </Box>
                                            </Box>

                                            <Box sx={{ display: 'flex', flexDirection:{md:'row', xs:'column'}, pt: 5, gap: 3, ml: 5 }}>
                                                <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Number of Session:  <span style={{ color: '#2544EE' }}> 3</span></Typography></Box>
                                                <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Service Duration : <span style={{ color: '#2544EE' }}> 130 Minutes </span></Typography></Box>
                                                <Box sx={servicefeature}><Typography sx={{ px: 5, py: 3 }} className="text1Mid">Duration/Session:  :<span style={{ color: '#2544EE' }}>  4 </span></Typography></Box>
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box>
                                        <Grid container>
                                            <Grid item xs={12} md={4}>
                                                <Typography className="subHeading2Bold" sx={{ textAlign: 'center' }}>
                                                    <span>Date & Time</span>
                                                    <br />
                                                    <span className="text1Mid">25 April & 2:00PM</span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <Typography
                                                    sx={{ textAlign: 'center' }}
                                                    className="subHeading2Bold">
                                                    <span>Price</span>
                                                    <br />
                                                    <span className="text1Bold" sx={{ color: '#000' }}>₹8000/-</span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <Typography sx={{ textAlign: 'center' }}
                                                    className="subHeading2Bold">
                                                    <span>Payment</span>
                                                    <br />
                                                    <span className="text1Mid" sx={{ color: '#17BB05' }}>UPI ID: ibnhiew@</span>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                                        <Button variant="contained" className="text1Mid" sx={{ px: 5, py: 2, bgcolor: '#2544EE', borderRadius: '30px', mb: 5 }} >Reschedule Service <ArrowForwardIos sx={{ fontSize: '0.85rem' }} /></Button>
                                        <Button variant="outlined" className="text1Mid" sx={{ px: 5, py: 2, color: '#FFF', bgcolor: '#FF0000', borderRadius: '30px', ml: 5, mb: 5 }}>Cancel Service <ArrowForwardIos sx={{ fontSize: '0.85rem' }} /></Button>
                                    </Box>
                                </Paper>
                            </Box>
                        </Grid>
                        <Grid item md={3} xs={12} >
                            <Box sx={{ p: 1, my: 1 }}>
                                <Typography variant="body1" className='text1Bold'>
                                    Social Media
                                </Typography>
                                <Grid container>
                                    <Grid item md={2}>
                                        <img src={facebookIcon} alt='Facebook' width={'25px'} />
                                    </Grid>
                                    <Grid item md={2}>
                                        <img src={twitterIcon} alt='twitter' width={'25px'} />
                                    </Grid>
                                    <Grid item md={2}>
                                        <img src={linkedinIcon} alt='liinkedin' width={'25px'} />
                                    </Grid>
                                    <Grid item md={2}>
                                        <img src={instagramIcon} alt='instagram' width={'25px'} />
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box sx={{ p: 1, my: 1 }}>
                                <Typography variant="body1" className='text1Bold'>
                                    Reviews
                                </Typography>
                                <CandidateCoachServiceReviewCard />
                                <CandidateCoachServiceReviewCard />
                                <CandidateCoachServiceReviewCard />
                                <CandidateCoachServiceReviewCard />
                                <CandidateCoachServiceReviewCard />
                            </Box>
                        </Grid>
                    </Grid>
                </UserLayout >
            </Layout >
        </>
    )
}

export default CandidateServiceOrderDetailPage;